import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';
import ContainedButton from '../../shared/Button/CustomContainedButton';
import OutlinedButton from '../../shared/Button/customOutlinedButton';
import style from '../CSS/Base.module.css';

type PopUpProps = {
  open: boolean;
  handleClose: () => void;
  saveChanges: () => void;
  message: string;
  popupTitle: string;
  disabled?: boolean
};

export default function PopUp(props: PopUpProps) {
  const { open, handleClose, saveChanges, message, popupTitle, disabled } = props;
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description" 
      sx={{ '& .MuiDialog-paper': { minWidth: '25%' } }}
    >
      <DialogTitle sx={{
        backgroundColor: "#059ca9",
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 10px' 
      }}>
        {popupTitle} 

        {popupTitle !== "Session Time Out" && (<IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: "white",
            padding: '0px'
          }}
        >
          <CloseIcon />
        </IconButton>)}
      </DialogTitle>
      <DialogContent style={{ paddingTop: '20px' }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            whiteSpace: 'normal', // allow wrapping
            overflowWrap: 'break-word', // break long words
            wordBreak: 'break-word', // ensure long words wrap
            fontSize: '1rem' 
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <DialogActions sx={{ padding: '0px' }}>
          <ContainedButton onClick={saveChanges} autoFocus disabled={disabled}>
            {popupTitle === "Session Time Out" ? "Ok" : translate('yes')}
          </ContainedButton>

          {popupTitle !== "Session Time Out" && (
            <OutlinedButton onClick={handleClose}>
              {translate('no')}
            </OutlinedButton>
          )}
        </DialogActions>

      </DialogActions>
    </Dialog>
  );
}
